import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ModuleCodename, useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";
import Screens from "constants/screens";
import Constants from "constants/index";

import { RootState } from "store";
import { Mode } from 'constants/enum';
import { DashboardLayout } from "layout";
import { IModel } from "commons/interfaces";
import { setListPathName } from "store/slice/titleRoute.slice";



const CodenameScreen = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { getResourcePermissions } = useCommonComponentContext();

    const idDetail: string = searchParams.get("id");
    const modeList = (Screens.CODENAME_LIST.includes(window.location.pathname));
    const pramsMode = !Helpers.isNullOrEmpty(searchParams.get("mode")) ? Number(searchParams.get("mode")) : undefined;


    const resourcePermissions = getResourcePermissions(Constants.ResourceCode.CODENAME);
    const listPathName = useSelector((state: RootState) => state.titleRoute.listPathName);
    const itemPathName = listPathName.find((el: any) => el.pathName === Screens.CODENAME_LIST);

    const [model, setModel] = useState<IModel>({});

    useEffect(() => {
        if (Helpers.isNullOrEmpty(idDetail)) {
            handleChangeMode(Mode.Create);
        } else {
            const mode = resourcePermissions.canUpdate ? (pramsMode || Mode.Update) : Mode.View;
            handleChangeMode(mode);
        }
    }, [idDetail, pramsMode]);

    const [requestData] = useState<any>({
        code: searchParams.get("code"),
        group: searchParams.get("group"),
        searchText: searchParams.get("searchText"),
        totalCount: itemPathName?.totalCount || 0,
        pageNumber: Number(searchParams.get("pageNumber") || 1),
        pageSize: Number(searchParams.get("pageSize") || Constants.ROW_PER_PAGE),
    });

    const handleChangeMode = (value: Mode) => {
        let title: string = "";
        let route = [{ title: Strings.CODE_NAME.TITLE_MENU, route: Screens.CODENAME_LIST }];

        if (value === Mode.Create) {
            title = Strings.CODE_NAME.TITLE_CREATE_VIEW;
            route = [
                { title: Strings.CODE_NAME.TITLE_MENU, route: Screens.CODENAME_LIST },
                { title: Strings.Common.CREATE_NEW, route: "" }
            ];
        }
        if (value === Mode.Update) {
            title = Strings.CODE_NAME.TITLE_UPDATE_VIEW;
            route = [
                { title: Strings.CODE_NAME.TITLE_MENU, route: Screens.CODENAME_LIST },
                { title: Strings.Common.UPDATE, route: "" }
            ];
        }
        if (value === Mode.View) {
            title = Strings.CODE_NAME.TITLE_DETAIL_VIEW;
            route = [
                { title: Strings.CODE_NAME.TITLE_MENU, route: Screens.CODENAME_LIST },
                { title: Strings.Common.VIEW, route: "" }
            ];
        }

        setModel({
            ...model,
            mode: value,
            title: title,
            route: route,
        });

        if (!Helpers.isNullOrEmpty(idDetail)) {
            navigate(Screens.CODENAME_EDIT + `?id=${idDetail}&mode=${value}`, { replace: true });
        }
    }

    const handleGoBack = () => {
        const itemPathName = listPathName.find(el => el.pathName === Screens.CODENAME_LIST);
        navigate(Screens.CODENAME_LIST + (itemPathName ? itemPathName.query : ""));
    }
    //

    return (
        <DashboardLayout
            isPermission={resourcePermissions.canRead}
            title={modeList ? Strings.CODE_NAME.TITLE_MENU : model.title}
            route={modeList ? [{ title: Strings.CODE_NAME.NAME, route: "" }] : model.route}
        >
            <>
                <ModuleCodename
                    hiddenActionCreate={!resourcePermissions.canCreate}
                    hiddenActionDelete={!resourcePermissions.canDelete}
                    hiddenActionUpdate={!resourcePermissions.canUpdate}
                

                    keyModuleContainer={{
                        list: { pathName: Screens.CODENAME_LIST },
                        detail: { pathName: Screens.CODENAME_EDIT },
                        create: { pathName: Screens.CODENAME_CREATE },
                    }}

                    requestGetPaged={requestData}
                    onGetPaged={({ query, totalCount }) => {
                        dispatch(setListPathName({ query, totalCount, pathname: Screens.CODENAME_LIST, }));
                        navigate(Screens.CODENAME_LIST + query, { replace: true });
                    }}
                    onNavigate={(data) => {
                        if (!Helpers.isNullOrEmpty(data.id)) {
                            navigate(Screens.CODENAME_EDIT + `?id=${data.id}&mode=${data.mode}`);
                        } else {
                            navigate(Screens.CODENAME_CREATE);
                        }
                    }}

                    mode={model.mode}
                    idDetail={idDetail}
                    onGoBack={handleGoBack}
                    onChangeMode={(value) => { handleChangeMode(value); }}
                />
            </>
        </DashboardLayout>
    );
};

export default CodenameScreen;
